var _path, _path2, _path3, _path4, _g, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUangBelanjaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.11364C0 1.84174 1.72667 0 3.85663 0H25.7109C27.8408 0 29.5675 1.84174 29.5675 4.11364V23.482C29.5675 25.7539 27.8408 27.5957 25.7109 27.5957H3.85663C1.72667 27.5957 0 25.7539 0 23.482V4.11364Z",
    fill: "#1E54A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18091 4.97927C4.18091 3.27535 5.47591 1.89404 7.07338 1.89404H29.5704C31.1679 1.89404 32.4629 3.27535 32.4629 4.97927V27.9471C32.4629 29.651 31.1679 31.0323 29.5704 31.0323H7.07338C5.47591 31.0323 4.18091 29.651 4.18091 27.9471V4.97927Z",
    fill: "#E4C342"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.56994C0 6.29804 1.72667 4.4563 3.85663 4.4563H30.853C32.983 4.4563 34.7097 6.29804 34.7097 8.56994V29.6523C34.7097 31.9242 32.983 33.766 30.853 33.766H3.85663C1.72667 33.766 0 31.9242 0 29.6523V8.56994Z",
    fill: "#1E54A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_932_21162",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 34,
    height: 30
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00561523 8.60091C0.00561523 6.31069 1.69112 4.4541 3.7703 4.4541H30.1231C32.2023 4.4541 33.8878 6.31069 33.8878 8.60091V29.8533C33.8878 32.1435 32.2023 34.0001 30.1231 34.0001H3.7703C1.69112 34.0001 0.00561523 32.1435 0.00561523 29.8533V8.60091Z",
    fill: "#1E54A5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_932_21162)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-29.3302 46.0245C-1.4665 49.9315 29.221 13.8154 39.0013 -5.77536L48.71 -0.901759L19.2133 70.3925L-29.3302 46.0245Z",
    fill: "#1C3E7B"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6628 15.6056C22.6628 15.0376 23.0945 14.5771 23.627 14.5771H34.072C35.137 14.5771 36.0004 15.498 36.0004 16.634V20.4048C36.0004 21.5408 35.137 22.4616 34.072 22.4616H23.627C23.0945 22.4616 22.6628 22.0012 22.6628 21.4332V15.6056Z",
    fill: "#4A76BE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4447 18.4218C28.4447 19.5104 27.6174 20.3929 26.5967 20.3929C25.5761 20.3929 24.7488 19.5104 24.7488 18.4218C24.7488 17.3332 25.5761 16.4507 26.5967 16.4507C27.6174 16.4507 28.4447 17.3332 28.4447 18.4218Z",
    fill: "#FAEFE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUangBelanjaIcon);
export default __webpack_public_path__ + "static/media/uang-belanja-icon.54bdd9cecb8a78171734b3e6ede381bf.svg";
export { ForwardRef as ReactComponent };